import "@assets/css/components/DashboardUsuarios/DataTables/style.css";

import { Col, Container, Row } from "react-bootstrap";
import {
  ModalSweetAlert,
  Notificacion,
} from "@components/general/Alertas/Alertas";
import React, { useMemo, useState } from "react";
import {
  faEdit,
  faEye,
  faPowerOff,
  faTimes,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";

import { DataTablesRecipient } from "@components/general/DataTablesRecipient/DataTablesRecipient";
import { EditarAsesor } from "../../Modales/Asesor/EditarAsesor/EditarAsesor";
import { EliminarAsesor } from "../../Modales/Asesor/EliminarAsesor/EliminarAsesor";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VerAsesor } from "../../Modales/Asesor/VerAsesor/VerAsesor";
import columnasAsesor from "./columnasAsesor";
import { getAsesores } from "@helpers/httpRequests/httpRequestsUsuarios/asesores/httpRequestsAsesores";
import { reactivateUsuario } from "@helpers/httpRequests/httpRequestsUsuarios/httpRequestsUsuarios";
import { useEffect } from "react";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import { Box, IconButton } from "@mui/material";
import { FaEdit, FaEye, FaPowerOff, FaTrash } from "react-icons/fa";
import getLocalStorage from "@helpers/localStorage/getLocalStorage";
import localStorageItemNames from "@helpers/localStorage/localStorageItemNames";

export const TableAsesor = () => {
  const [asesores, setAsesores] = useState([]);

  const [dataTableColumns, setDataTableColumns] = useState([]);

  const [asesorEditado, setAsesorEditado] = useState(false);

  const [asesorEliminado, setAsesorEliminado] = useState(false);

  const [asesorReactivado, setAsesorReactivado] = useState(false);

  const [busquedaActiva, setBusquedaActiva] = useState(
    getLocalStorage(localStorageItemNames.busquedaUsuarioActiva, false)
  );

  const handleVerDatosAsesor = async ({ currentTarget }) => {
    try {
      const idPersona = parseInt(currentTarget.id);

      const dataAsesor = asesores.filter(
        (asesor) => asesor.idPersona === idPersona
      )[0];

      console.log("Mostrando datos del asesor: ", dataAsesor);

      await ModalSweetAlert({
        html: <VerAsesor asesor={dataAsesor} />,
        showConfirmButton: false,
        showCloseButton: true,
      });
    } catch (error) {
      console.log("Error al consultar los datos del asesor", error);
    }
  };

  const handleEditDatosAsesor = async ({ currentTarget }) => {
    try {
      const idPersona = parseInt(currentTarget.id);

      const dataAsesor = asesores.filter(
        (asesor) => asesor.idPersona === idPersona
      )[0];

      await ModalSweetAlert({
        title: "Actualizar datos de asesor",
        html: (
          <EditarAsesor
            asesor={dataAsesor}
            setAsesorEditado={setAsesorEditado}
          />
        ),
        showConfirmButton: false,
        showCloseButton: true,
      });
    } catch (error) {
      console.log("Error al actualizar los datos del asesor: ", error);
    }
  };

  const handleDeactivateAsesor = async ({ currentTarget }) => {
    try {
      const idPersona = parseInt(currentTarget.id);

      const dataAsesor = asesores.filter(
        (asesor) => asesor.idPersona === idPersona
      )[0];

      await ModalSweetAlert({
        title: "Eliminar asesor",
        icon: "warning",
        html: (
          <EliminarAsesor
            asesor={dataAsesor}
            setAsesorEliminado={setAsesorEliminado}
          />
        ),
        showConfirmButton: false,
        showCloseButton: true,
      });
    } catch (error) {
      console.log("Error al desactivar al asesor: ", error);
    }
  };

  const handleReactivateAsesor = async ({ currentTarget }) => {
    try {
      const idPersona = parseInt(currentTarget.id);

      const dataAsesor = asesores.filter(
        (asesor) => asesor.idPersona === idPersona
      )[0];

      await reactivateUsuario(dataAsesor.idCredencial);

      setAsesorReactivado(true);

      Notificacion("success", "El asesor se reactivó correctamente");
    } catch (error) {
      console.log("Error al reactivar al asesor: ", error);
    }
  };

  useEffect(() => {
    const consultarAsesores = async () => {
      try {
        let { data: asesores } = await getAsesores();

        if (!Array.isArray(asesores)) {
          asesores = [asesores];
        }

        setAsesores(
          asesores.sort(
            (a, b) => parseInt(a.folioContrato) - parseInt(b.folioContrato)
          )
        );
      } catch (error) {
        console.log("Error al consultar los asesores registrados: ", error);
      }
    };

    const dataBusqueda = getLocalStorage(
      localStorageItemNames.busquedaUsuarioData,
      ""
    );

    if (busquedaActiva && dataBusqueda.rol === "asesor") {
      setAsesores([dataBusqueda]);
    } else {
      consultarAsesores();
    }
  }, []);

  // useEffect(() => {
  // 	if (asesores.length > 0) {

  // 		setDataTableColumns([
  // 			...columnasAsesor,
  // 			{
  // 				name: "Acciones",
  // 				cell: (row) => (
  // 					<>
  // 						<span id={`select-${row.idPersona}`} className="me-1 pointer" onClick={handleVerDatosAsesor}>
  // 							<FontAwesomeIcon icon={faEye} className='text-primary' />
  // 						</span>

  // 						<span id={`edit-${row.idPersona}`} className="me-1 pointer" onClick={handleEditDatosAsesor}>
  // 							<FontAwesomeIcon icon={faEdit} className='text-info' />
  // 						</span>

  // 						{row.estatusCredencial ? (
  // 							<span id={`delete-${row.idPersona}`} className="me-1 pointer" onClick={handleDeactivateAsesor}>
  // 								<FontAwesomeIcon icon={faTrashAlt} className='text-danger' />
  // 							</span>
  // 						) : (
  // 							<span id={`reactivate-${row.idPersona}`} className="me-1 pointer" onClick={handleReactivateAsesor}>
  // 								<FontAwesomeIcon icon={faPowerOff} className='text-success' />
  // 							</span>
  // 						)}
  // 					</>
  // 				),
  // 				ignoreRowClick: true,
  // 				allowOverflow: true,
  // 				button: true,
  // 			}
  // 		]);
  // 	}
  // }, [asesores]);

  useEffect(() => {
    if (asesorEditado || asesorEliminado || asesorReactivado) {
      const consultarAsesores = async () => {
        try {
          const { data: asesores } = await getAsesores();

          setAsesores(asesores);

          setAsesorEditado(false);

          setAsesorEliminado(false);

          setAsesorReactivado(false);
        } catch (error) {
          console.log("Error al consultar los asesores registrados: ", error);
        }
      };

      consultarAsesores();
    }
  }, [asesorEditado, asesorEliminado, asesorReactivado]);

  const columnas = useMemo(() => [
    {
      accessorKey: "folioGrupo",
      header: "Folio",
      size: 50,
    },
    {
      accessorKey: "nombreCompleto",
      header: "Nombre",
    },
    {
      accessorKey: "apellidos",
      header: "Apellidos",
    },
    {
      accessorKey: "correo",
      header: "Correo",
    },
    {
      accessorKey: "curp",
      header: "CURP",
    },
  ]);

  const handleBorrarBusqueda = async () => {
    localStorage.removeItem("busquedaUsuarioData");
    localStorage.removeItem("busquedaUsuarioActiva");

    try {
      const { data: asesores } = await getAsesores();

      setAsesores(asesores);

      setAsesorEditado(false);

      setAsesorEliminado(false);

      setAsesorReactivado(false);
    } catch (error) {
      console.log("Error al consultar los asesores registrados: ", error);
    }
  };

  return (
    <Container fluid>
      <Row>
        {busquedaActiva && asesores.length === 1 && (
          <Col className="mb-3 mt-3 col-12">
            <h4>
              Busqueda por asesor:{" "}
              <span style={{ color: "grey" }}>
                {" "}
                {asesores[0].nombreCompleto + " " + asesores[0].apellidos}
              </span>{" "}
              <FontAwesomeIcon
                onClick={handleBorrarBusqueda}
                className="mx-2 pointer"
                icon={faTimes}
                color="#dc3545"
              />
            </h4>
          </Col>
        )}
        <Col>
          {/* {
						asesores.length < 1 && <SpinnerImage />
					}
					{
                        asesores.length > 0 &&
                        <DataTablesRecipient columns={dataTableColumns} data={asesores} />
                        
                    } */}

          {/* <DataTablesRecipient columns={dataTableColumns} data={asesores} /> */}

          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columnas}
            data={asesores}
            enableRowActions
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => (
              <Box sx={{ display: "flex", flexWrap: "nowrap", gap: "8px" }}>
                <IconButton
                  color="primary"
                  id={row.original.idPersona}
                  onClick={handleVerDatosAsesor}
                >
                  <FaEye className="text-info" />
                </IconButton>

                <IconButton
                  color="secondary"
                  id={row.original.idPersona}
                  onClick={handleEditDatosAsesor}
                >
                  <FaEdit className="text-primary" />
                </IconButton>

                {row.original.estatusCredencial ? (
                  <IconButton
                    color="secondary"
                    id={`${row.original.idPersona}`}
                    onClick={handleDeactivateAsesor}
                  >
                    <FaTrash color="red" />
                  </IconButton>
                ) : (
                  <IconButton
                    color="secondary"
                    id={`${row.original.idPersona}`}
                    onClick={handleReactivateAsesor}
                  >
                    <FaPowerOff color="green" />
                  </IconButton>
                )}
              </Box>
            )}
          />
        </Col>
      </Row>
    </Container>
  );
};
